import { render, staticRenderFns } from "./VisualEditor.vue?vue&type=template&id=5fd61c86&"
import script from "./VisualEditor.vue?vue&type=script&lang=js&"
export * from "./VisualEditor.vue?vue&type=script&lang=js&"
import style0 from "./VisualEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports